export const TAG_STYLES = {
  "happening": "bg-[#EBF0FB] text-[#4272DD]",
  "upcoming": "bg-[#FFF6E7] text-[#FFAB1F]",
  "past": "bg-[#F3F3F3] text-[#667085] border",
  "scheduled": "bg-[#c8f7d9] text-[#019939]",
  "urgent": "bg-[#FFF6E7] text-[#EC980C]",
  "approval": "text-[#E12121] border border-[#FFC9C9]",
  "refill": "bg-[#E6F5EB] text-[#019939]",
  "review": "bg-[#F3F3F3] text-[#667085]",
  "completed": "bg-[#E6FAF2] text-[#00C781] border border-[#00C78133]",
  "cancelled": "bg-[#F1F1F1] text-[#202020CC] "
} as const;

export type EncounterTagStatusType = keyof typeof TAG_STYLES;